import { Box } from '@mui/material';
import { ReactNode } from 'react';

interface FiltersWrapperProps {
  children: ReactNode;
}

export const FiltersWrapper = ({ children }: FiltersWrapperProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        gap: 2,
        flexWrap: 'wrap',
        alignItems: 'center',
      }}
    >
      {children}
    </Box>
  );
};
